import React, { useEffect } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
  duration?: number;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, duration);

    return () => clearTimeout(timer);
  }, [onComplete, duration]);

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center">
      <div className="text-center animate-pulse">
        <div className="mb-6">
          <div className="w-32 h-32 mx-auto bg-white rounded-full flex items-center justify-center shadow-2xl">
            <span className="text-5xl font-bold text-primary-600">SDA</span>
          </div>
        </div>
        <h1 className="text-4xl font-bold text-white mb-2">School Fee Payment</h1>
        <p className="text-xl text-primary-100">Seventh Day Adventist School Ranchi</p>
      </div>
    </div>
  );
};

export default SplashScreen;
